import {DEFAULT_PRESET_COLOR, NEUTRAL_PRESET_COLOR, PRESET_COLORS} from '../constants/presetColors';

// Resolve both previous palettes without rewriting saved preferences.
const LEGACY_PRESET_COLORS = new Map<string, string>([
  ['#0052CC', '#0065FF'],
  ['#2E3A59', NEUTRAL_PRESET_COLOR],
  ['#DE350B', '#E32C1E'],
  ['#00875A', '#24A148'],
  ['#FFB400', '#FFD600'],
  ['#E5508C', '#EE5396'],
  ['#00C7E6', '#00B1D0'],
  ['#8777D9', '#6554C0'],
  ['#E56910', '#FF9800'],
  ['#06B6D4', '#00B1D0'],
  ['#262A98', '#0065FF'],
  ['#EF4444', '#E32C1E'],
  ['#10B981', '#24A148'],
  ['#F59E0B', '#FFD600'],
  ['#EC4899', '#EE5396'],
  ['#8894AA', NEUTRAL_PRESET_COLOR],
  ['#8B5CF6', '#6554C0'],
  ['#F97316', '#FF9800'],
]);

const SUPPORTED_PRESET_COLORS = new Set<string>(PRESET_COLORS);

export function resolvePresetColor(color: string | undefined) {
  const normalizedColor = color?.toUpperCase() ?? '';
  if (normalizedColor === '') {
    return DEFAULT_PRESET_COLOR;
  }
  const resolvedColor = LEGACY_PRESET_COLORS.get(normalizedColor) ?? normalizedColor;

  return SUPPORTED_PRESET_COLORS.has(resolvedColor) ? resolvedColor : NEUTRAL_PRESET_COLOR;
}
